// extracted by mini-css-extract-plugin
export var lg = "_1o-4";
export var md = "_1o-3";
export var sm = "_1o-2";
export var xs = "_1o-1";
export var xxs = "_1o-0";